<template>
  <div class="contain_box">
    <div class="header">
      <div class="left">
        <div class="background">
          <span :class="[{'item':isLive==1}]" @click="changeLive(1)">投稿</span>
          <span :class="[{'item':isLive==2}]" @click="changeLive(2)">直播</span>
        </div>
      </div>
      <div class="right">
        <span class="button">全部作品 <i class="el-icon-caret-bottom"></i></span>
        <span class="button">近90天 <i class="el-icon-caret-bottom"></i></span>
      </div>
    </div>
    <div class="list_box">
      <div class="header">
        <div class="title">投稿列表</div>
        <div class="button">点赞倒序 <i class="el-icon-caret-bottom"></i></div>
      </div>
      <div class="video_data_list">
        <div class="item_list" v-for="item in videoList" :key="item.videoId" @click="getVideoDetial(item.videoId)">
          <div class="show_video">
            <div class="img_box">
              <img :src="item.img" alt="">
              <span class="time">{{ item.video_time }}</span>
            </div>
            <div class="video_info">
              <div class="title">{{ item.title}}</div>
              <div class="time">{{ item.release_time }} 发布</div>
            </div>
          </div>
          <div class="show_number">
            <div class="number">
              <div class="name">播放</div>
              <div class="num">{{ item.play_num }}</div>
            </div>
            <div class="number">
              <div class="name">点赞</div>
              <div class="num">{{ item.like_num }}</div>
            </div>
            <div class="number">
              <div class="name">评论</div>
              <div class="num">{{ item.review_num }}</div>
            </div>
            <div class="number">
              <div class="name">分享</div>
              <div class="num">{{ item.share_num }}</div>
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLive: 1,
      videoList: [
        {
          img: require("../../assets/img/image/video_image0.jpeg"),
          video_url: "",
          videoId: 1,
          title:
            "咱就是说好这一口五彩椒，它不辣甚至有点甜D#女生必看#好吃到停不下来 #彩椒 #抖音美食推荐官 #超好吃",
          release_time: "2025-02-08 21:29",
          play_num: "45.7万",
          like_num: "614",
          review_num: "34",
          share_num: "263",
          video_time: "00:23",
        },
        {
          img: require("../../assets/img/image/video_img1.jpg"),
          video_url: "",
          videoId: 2,
          title:
            "姐妹们他真的夹到我了,可把我乐坏了#ally#做精致女人#男朋友#女生必备 #分享生活",
          release_time: "2025-02-08 21:29",
          play_num: "3.7万",
          like_num: "205",
          review_num: "4",
          share_num: "100",
          video_time: "00:44",
        },
      ],
    };
  },
  props: {},
  mounted() {},

  methods: {
    changeLive(id) {
      this.isLive = id;
    },
    getVideoDetial(id){
      this.$router.push({path:"/training/workDataDetails",query:{video_id:id}})
    }
  },
};
</script>

<style scoped lang="scss">
.contain_box {
  padding: 0 10px;
  box-sizing: border-box;
  background: #f5f5f5;
  .header {
    // margin-top: 20px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background: #f5f5f5;
    .left {
      display: flex;
      align-items: center;
      .el-icon-arrow-right {
        margin-left: 5px;
        font-size: 16px;
        font-weight: 600;
      }
      .background {
        background: #e9e9ea;
        padding: 4px 4px;
        border-radius: 2px;
        font-size: 14px;
        .item {
          background: #fff;
        }
        span {
          border-radius: 2px;
          padding: 2px 3px;
          cursor: pointer;
          &:nth-of-type(1) {
            margin-right: 5px;
          }
        }
      }
    }
    .right {
      .button {
        padding: 6px 8px;
        background: #e9e9ea;
        border-radius: 2px;
        &:nth-of-type(1) {
          margin-right: 10px;
        }
      }
    }
  }
  .list_box {
    width: 100%;
    // height: 300px;
    background: #fff;
    border-radius: 4px;
    margin-top: 15px;
    padding: 20px 10px;
    box-sizing: border-box;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;

      .title {
        font-size: 16px;
        font-weight: 600;
      }
      .button {
        font-size: 14px;
        color: #73747a;
      }
    }
    .video_data_list {
      .item_list {
        width: 100%;
        height: 210px;
        border-bottom: 1px solid #fafafa;
        padding: 20px 0;
        box-sizing: border-box;
        cursor: pointer;
        .show_video {
          display: flex;
       
          .img_box {
            flex-shrink: 0;
            width: 80px;
            height: 110px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 8px;
            }
            .time{
              position: absolute;
              bottom: 2px;
              right: 2px;
              color: #fff;
              
            }
          }
          .video_info {
            flex: 1;
            width: 0;
            height: 110px;
            margin-left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title {
              width: 100%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2; /* 显示的行数 */
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 15px;
              font-weight: 600;
              letter-spacing: 1px;
            }
          }
        }
        .show_number {
          margin-top: 20px;
          display: flex;
          .number {
            flex: 1;
            .name {
              text-align: center;
              font-size: 14px;
              color: #c9c9cc;
            }
            .num {
              text-align: center;
              font-weight: 600;
              font-size: 16px;
              margin-top: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
